import {
  ChoiceGroup,
  IChoiceGroupOptionStyles,
  IChoiceGroupOption,
} from '@fluentui/react';
import { useDownloadData } from '../context';
import { useTranslation } from 'react-i18next';
import { DownloadFileType } from '../types';

/**
 * Custom styles for the FileTypeCard's options.
 */
const optionStyles: IChoiceGroupOptionStyles = {
  //make the options resize
  root: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: '10em',
  },
  //make the option labels fit on screen
  labelWrapper: { height: '5em', maxWidth: 'unset' },
  choiceFieldWrapper: { width: '100%' },
};

/**
 * Renders a large button for selecting a specific file type
 * for the exported spreadsheet.
 */
export const FileTypeCard = () => {
  const [t] = useTranslation('download');
  const { fileType, setFileType } = useDownloadData();

  const options: IDownloadChoiceGroupOption[] = [
    {
      key: DownloadFileType.xlsx,
      text: t('type.xlsx', 'xlsx'),
      iconProps: { iconName: 'ExcelDocument' },
      styles: optionStyles,
    },
    {
      key: DownloadFileType.csv,
      text: t('type.csv', 'csv'),
      iconProps: { iconName: 'Table' },
      styles: optionStyles,
    },
  ];
  const onChange = (e, item?: IChoiceGroupOption) => {
    setFileType(item?.key as DownloadFileType);
  };

  return (
    <ChoiceGroup
      label={t('Select file type')}
      {...{
        selectedKey: fileType,
        options,
        onChange,
      }}
    />
  );
};
type IDownloadChoiceGroupOption = Omit<IChoiceGroupOption, 'key'> & {
  key: DownloadFileType;
};
